import React from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl, SegmentedControlItem } from 'web-ui-components/lib/molecules/forms';
import { contentPropTypes } from './PayeePicker.content';

const PayeePickerToggle = ({
	isManageYourPayee,
	onShowPayees,
	onShowAccounts,
	ukPayees,
	onUKPayees,
	onInternationalPayees,
	showPayees,
	content,
	isIFTEnabled,
}) => {
	if (isManageYourPayee) {
		if (!isIFTEnabled) {
			return null;
		}
		return (
			<SegmentedControl>
				<SegmentedControlItem checked={ukPayees} id="accountpicker-header-show-uk-payees" onClick={onUKPayees}>
					{content.ukPayees}
				</SegmentedControlItem>
				<SegmentedControlItem
					checked={!ukPayees}
					id="accountpicker-header-show-international-payees"
					onClick={onInternationalPayees}
				>
					{content.internationalPayees}
				</SegmentedControlItem>
			</SegmentedControl>
		);
	}
	return (
		<SegmentedControl>
			<SegmentedControlItem checked={showPayees} id="accountpicker-header-show-payees" onClick={onShowPayees}>
				{content.yourPayees}
			</SegmentedControlItem>
			<SegmentedControlItem
				checked={!showPayees}
				id="accountpicker-header-show-accounts-in-payees"
				onClick={onShowAccounts}
			>
				{content.yourAccounts}
			</SegmentedControlItem>
		</SegmentedControl>
	);
};

PayeePickerToggle.propTypes = {
	isManageYourPayee: PropTypes.bool,
	onShowPayees: PropTypes.func,
	onShowAccounts: PropTypes.func,
	ukPayees: PropTypes.bool,
	onUKPayees: PropTypes.func,
	onInternationalPayees: PropTypes.func,
	showPayees: PropTypes.bool,
	isIFTEnabled: PropTypes.bool,
	content: PropTypes.shape(contentPropTypes),
};

export default PayeePickerToggle;
